import { motion } from "framer-motion";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Card, CardContent } from "./components/Card";
import { Button } from "./components/Button";
import madalinaImg from "C:/Proiecte/socrate/src/Membrii/MembruMadalina.png";
import horatiuImg from "C:/Proiecte/socrate/src/Membrii/MembruHoratiu.jfif";
import samuelImg from "C:/Proiecte/socrate/src/Membrii/MembruSamuel.jpg";
import maniovImg from "C:/Proiecte/socrate/src/Membrii/MembruManiov.jpg";
import mariusbImg from "C:/Proiecte/socrate/src/Membrii/MembruMariusB.jpg";
import klausImg from "C:/Proiecte/socrate/src/Membrii/MembruKlaus.png";
// Pagini
import Doneaza from "./pages/Doneaza";
import Voluntar from "./pages/Voluntar";
import Directioneaza3LaSuta from "./pages/Directioneaza3LaSuta";
import Contact from "./pages/Contact";
import Galerie from "./pages/Galerie";

export default function App() {


  // Membrii (afișați pe homepage)
  const teamMembers = [
    {
      name: "Prof.univ.dr. Șoim Horațiu",
      subtitle: "Ateliere și programe pentru elevi",
      image: horatiuImg,
    },

    {
      name: "Prof.univ.dr. Klaus Schebesch ",
      subtitle: "Mentorat și orientare în carieră",
      image: klausImg,
    },
    {
      name: "Conf.univ.dr. Boiță Marius ",
      subtitle: "Dezvoltare personală",
      image: mariusbImg,
    },
    {
      name: "Conf.univ.dr. Maniov Vichentie",
      subtitle: "Cercetare și Antreprenoriat",
      image: maniovImg
    },
    {
      name: "Asist.univ.drd. Nicoară Samuel",
      subtitle: "Ateliere și programe pentru elevi",
      image: samuelImg
    },
    {
      name: "Ec. Blaga Mădălina",
      subtitle: "Activități de Marketing și Promovare",
      image: madalinaImg,
    },

  ];

  // Galerie: preview pe homepage + folosită în pagina /galerie
  // pozele se pun în /public/galerie/... și folosește src "/galerie/2013/01.jpg"
  // Poți să pui cele mai noi poze după const gallery Photos, să pară că e actualizat cu poze recente
  const galleryPhotos = [
    { id: "2026-001", src: "/galerie/2026/01.jpeg", alt: "20 Aprilie 2026", year: 2026, project: "Activități „Săptămâna Altfel”", order: 1 },
    { id: "2026-002", src: "/galerie/2026/02.jpeg", alt: "20 Aprilie 2026", year: 2026, project: "Activități „Săptămâna Altfel”", order: 1 },
    { id: "2026-003", src: "/galerie/2026/03.jpeg", alt: "20 Aprilie 2026", year: 2026, project: "Activități „Săptămâna Altfel”", order: 1 },
    { id: "2026-004", src: "/galerie/2026/04.jpeg", alt: "20 Aprilie 2026", year: 2026, project: "Activități „Săptămâna Altfel”", order: 1 },
    { id: "2025-018", src: "/galerie/2025/18.jpeg", alt: "Activități Educaționale", year: 2025, project: "Activități STEM", order: 1 },
    { id: "2025-019", src: "/galerie/2025/19.jpeg", alt: "Activități Educaționale", year: 2025, project: "Activități STEM", order: 1 },
    { id: "2012-001", src: "/galerie/2012/01.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-002", src: "/galerie/2012/02.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-003", src: "/galerie/2012/03.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-004", src: "/galerie/2012/04.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-005", src: "/galerie/2012/05.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-006", src: "/galerie/2012/06.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-007", src: "/galerie/2012/07.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-008", src: "/galerie/2012/08.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-009", src: "/galerie/2012/09.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun într-un centru pentru copii", order: 1 },
    { id: "2012-010", src: "/galerie/2012/10.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun alături de familii ", order: 1 },
    { id: "2012-011", src: "/galerie/2012/11.jpg", alt: "Activități Caritabile", year: 2012, project: "Crăciun alături de familii ", order: 1 },
    { id: "2012-012", src: "/galerie/2012/12.jpg", alt: "Activități Educaționale", year: 2012, project: "Zilele FSE ", order: 1 },
    { id: "2012-013", src: "/galerie/2012/13.jpg", alt: "Activități Educaționale", year: 2012, project: "Zilele FSE ", order: 1 },
    { id: "2012-014", src: "/galerie/2012/14.jpg", alt: "Activități Educaționale", year: 2012, project: "Zilele FSE ", order: 1 },
    { id: "2012-015", src: "/galerie/2012/15.jpg", alt: "Activități Educaționale", year: 2012, project: "Zilele FSE ", order: 1 },
    { id: "2012-016", src: "/galerie/2012/16.jpg", alt: "Activități Educaționale", year: 2012, project: "Zilele FSE ", order: 1 },
    { id: "2012-017", src: "/galerie/2012/17.jpg", alt: "Activități Educaționale", year: 2012, project: "Zilele FSE ", order: 1 },
    { id: "2012-018", src: "/galerie/2012/18.jpg", alt: "Activități Educaționale", year: 2012, project: "Zilele FSE ", order: 1 },
    { id: "2012-019", src: "/galerie/2012/19.jpg", alt: "Activități Educaționale", year: 2012, project: "Zilele FSE ", order: 1 },
    { id: "2013-001", src: "/galerie/2013/01.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-002", src: "/galerie/2013/02.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-003", src: "/galerie/2013/03.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-004", src: "/galerie/2013/04.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-005", src: "/galerie/2013/05.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-006", src: "/galerie/2013/06.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-007", src: "/galerie/2013/07.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-008", src: "/galerie/2013/08.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-009", src: "/galerie/2013/09.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-010", src: "/galerie/2013/10.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-011", src: "/galerie/2013/11.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-012", src: "/galerie/2013/12.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-013", src: "/galerie/2013/13.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-014", src: "/galerie/2013/14.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-015", src: "/galerie/2013/15.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-016", src: "/galerie/2013/16.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-017", src: "/galerie/2013/17.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2013-018", src: "/galerie/2013/18.jpg", alt: "Activități Caritabile", year: 2013, project: "Daruri din Inimă", order: 1 },
    { id: "2014-001", src: "/galerie/2014/01.jpg", alt: "Activități Educaționale", year: 2014, project: "Vizită la Ascent", order: 1 },
    { id: "2014-002", src: "/galerie/2014/02.jpg", alt: "Activități Educaționale", year: 2014, project: "Vizită la Ascent", order: 1 },
    { id: "2014-003", src: "/galerie/2014/03.jpg", alt: "Activități Educaționale", year: 2014, project: "Vizită la Ascent", order: 1 },
    { id: "2014-004", src: "/galerie/2014/04.jpg", alt: "Activități Educaționale", year: 2014, project: "Vizită la Ascent", order: 1 },
    { id: "2014-005", src: "/galerie/2014/05.jpg", alt: "Donare de sânge Aprilie", year: 2014, project: "Donare de sânge", order: 1 },
    { id: "2014-006", src: "/galerie/2014/06.jpg", alt: "Donare de sânge Aprilie", year: 2014, project: "Donare de sânge", order: 1 },
    { id: "2014-007", src: "/galerie/2014/07.jpg", alt: "Donare de sânge Aprilie", year: 2014, project: "Donare de sânge", order: 1 },
    { id: "2014-008", src: "/galerie/2014/08.jpg", alt: "Donare de sânge Aprilie", year: 2014, project: "Donare de sânge", order: 1 },
    { id: "2014-009", src: "/galerie/2014/09.jpg", alt: "Donare de sânge Aprilie", year: 2014, project: "Donare de sânge", order: 1 },
    { id: "2014-010", src: "/galerie/2014/10.jpg", alt: "Donare de sânge Aprilie", year: 2014, project: "Donare de sânge", order: 1 },
    { id: "2014-011", src: "/galerie/2014/11.jpg", alt: "Donare de sânge Aprilie", year: 2014, project: "Donare de sânge", order: 1 },
    { id: "2014-012", src: "/galerie/2014/12.jpg", alt: "Activități cu copiii", year: 2014, project: "Ziua copilului", order: 1 },
    { id: "2014-013", src: "/galerie/2014/13.jpg", alt: "Activități cu copiii", year: 2014, project: "Ziua copilului", order: 1 },
    { id: "2014-014", src: "/galerie/2014/14.jpg", alt: "Activități cu copiii", year: 2014, project: "Ziua copilului", order: 1 },
    { id: "2014-015", src: "/galerie/2014/15.jpg", alt: "Activități cu copiii", year: 2014, project: "Ziua copilului", order: 1 },
    { id: "2014-016", src: "/galerie/2014/16.jpg", alt: "Activități cu copiii", year: 2014, project: "Ziua copilului", order: 1 },
    { id: "2014-017", src: "/galerie/2014/17.jpg", alt: "Activități cu copiii", year: 2014, project: "Ziua copilului", order: 1 },
    { id: "2014-018", src: "/galerie/2014/18.jpg", alt: "Activități cu copiii", year: 2014, project: "Ziua copilului", order: 1 },
    { id: "2014-019", src: "/galerie/2014/19.jpg", alt: "Activități cu copiii", year: 2014, project: "Ziua copilului", order: 1 },
    { id: "2014-020", src: "/galerie/2014/20.jpg", alt: "Cadouri de Crăciun", year: 2014, project: "Daruri din Inimă", order: 1 },
    { id: "2014-021", src: "/galerie/2014/21.jpg", alt: "Cadouri de Crăciun", year: 2014, project: "Daruri din Inimă", order: 1 },
    { id: "2014-022", src: "/galerie/2014/22.jpg", alt: "Cadouri de Crăciun", year: 2014, project: "Daruri din Inimă", order: 1 },
    { id: "2014-023", src: "/galerie/2014/23.jpg", alt: "Cadouri de Crăciun", year: 2014, project: "Daruri din Inimă", order: 1 },
    { id: "2014-024", src: "/galerie/2014/24.jpg", alt: "Cadouri de Crăciun", year: 2014, project: "Daruri din Inimă", order: 1 },
    { id: "2014-025", src: "/galerie/2014/25.jpg", alt: "Cadouri de Crăciun", year: 2014, project: "Daruri din Inimă", order: 1 },
    { id: "2014-026", src: "/galerie/2014/26.jpg", alt: "Cadouri de Crăciun", year: 2014, project: "Daruri din Inimă", order: 1 },
    { id: "2015-001", src: "/galerie/2015/01.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Autoschunn - Guttenbrun", order: 1 },
    { id: "2015-002", src: "/galerie/2015/02.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Autoschunn - Guttenbrun", order: 1 },
    { id: "2015-003", src: "/galerie/2015/03.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Autoschunn - Guttenbrun", order: 1 },
    { id: "2015-004", src: "/galerie/2015/04.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Autoschunn - Guttenbrun", order: 1 },
    { id: "2015-005", src: "/galerie/2015/05.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Vizită de studiu la Hotel Leon", order: 1 },
    { id: "2015-006", src: "/galerie/2015/06.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Vizită de studiu la Hotel Leon", order: 1 },
    { id: "2015-007", src: "/galerie/2015/07.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Vizită de studiu la Hotel Leon", order: 1 },
    { id: "2015-008", src: "/galerie/2015/08.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Vizită de studiu la Hotel Leon", order: 1 },
    { id: "2015-009", src: "/galerie/2015/09.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Tehnomed AMG", order: 1 },
    { id: "2015-010", src: "/galerie/2015/10.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Tehnomed AMG", order: 1 },
    { id: "2015-011", src: "/galerie/2015/11.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Tehnomed AMG", order: 1 },
    { id: "2015-012", src: "/galerie/2015/12.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "Tehnomed AMG", order: 1 },
    { id: "2015-013", src: "/galerie/2015/13.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "TV Arad", order: 1 },
    { id: "2015-014", src: "/galerie/2015/14.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "TV Arad", order: 1 },
    { id: "2015-015", src: "/galerie/2015/15.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "TV Arad", order: 1 },
    { id: "2015-016", src: "/galerie/2015/16.jpg", alt: "Vizite cu Studenții la Firme", year: 2015, project: "TV Arad", order: 1 },
    { id: "2016-001", src: "/galerie/2016/01.jpg", alt: "Liceul Economic", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-002", src: "/galerie/2016/02.jpg", alt: "Liceul Economic", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-003", src: "/galerie/2016/03.jpg", alt: "Liceul „Henri Coandă”", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-004", src: "/galerie/2016/04.jpg", alt: "Liceul „Henri Coandă”", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-005", src: "/galerie/2016/05.jpg", alt: "Liceul „Henri Coandă”", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-006", src: "/galerie/2016/06.jpg", alt: "Liceul „Henri Coandă”", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-007", src: "/galerie/2016/07.jpg", alt: "Liceul „Henri Coandă”", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-008", src: "/galerie/2016/08.jpg", alt: "Liceul Particular „Vasile Goldiș”", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-009", src: "/galerie/2016/09.jpg", alt: "Liceul Particular „Vasile Goldiș", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-010", src: "/galerie/2016/10.jpg", alt: "Liceul Particular „Vasile Goldiș", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2016-011", src: "/galerie/2016/11.jpg", alt: "Liceul Particular „Vasile Goldiș", year: 2016, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2017-001", src: "/galerie/2017/01.jpg", alt: "Liceul „Henri Coandă”", year: 2017, project: "Consiliere antreprenorială și vocațională", order: 1 },
    { id: "2017-002", src: "/galerie/2017/01.jpg", alt: "Liceul „Henri Coandă”", year: 2017, project: "Consiliere antreprenorială și vocațională", order: 1 },
    { id: "2017-003", src: "/galerie/2017/01.jpg", alt: "Liceul „Henri Coandă”", year: 2017, project: "Consiliere antreprenorială și vocațională", order: 1 },
    { id: "2017-004", src: "/galerie/2017/04.jpg", alt: "Târgul Firmelor de Exercițiu", year: 2017, project: "Târgul Firmelor de Exercițiu", order: 1 },
    { id: "2017-005", src: "/galerie/2017/05.jpg", alt: "Târgul Firmelor de Exercițiu", year: 2017, project: "Târgul Firmelor de Exercițiu", order: 1 },
    { id: "2017-006", src: "/galerie/2017/06.jpg", alt: "Târgul Firmelor de Exercițiu", year: 2017, project: "Târgul Firmelor de Exercițiu", order: 1 },
    { id: "2017-007", src: "/galerie/2017/07.jpg", alt: "Târgul Firmelor de Exercițiu", year: 2017, project: "Târgul Firmelor de Exercițiu", order: 1 },
    { id: "2017-008", src: "/galerie/2017/08.jpg", alt: "Consiliere studenți UVVG", year: 2017, project: "Consiliere antreprenorială și vocațională în cadrul Universității de Vest „Vasile Goldiș” din Arad", order: 1 },
    { id: "2017-009", src: "/galerie/2017/09.jpg", alt: "Consiliere studenți UVVG", year: 2017, project: "Consiliere antreprenorială și vocațională în cadrul Universității de Vest „Vasile Goldiș” din Arad", order: 1 },
    { id: "2017-010", src: "/galerie/2017/10.jpg", alt: "Consiliere studenți UVVG", year: 2017, project: "Consiliere antreprenorială și vocațională în cadrul Universității de Vest „Vasile Goldiș” din Arad", order: 1 },
    { id: "2017-011", src: "/galerie/2017/11.jpg", alt: "Consiliere studenți UVVG", year: 2017, project: "Consiliere antreprenorială și vocațională în cadrul Universității de Vest „Vasile Goldiș” din Arad", order: 1 },
    { id: "2017-012", src: "/galerie/2017/12.jpg", alt: "Vizite cu Studenții la Firme", year: 2017, project: "Vizită de studiu la Hotel Continental din Arad", order: 1 },
    { id: "2017-013", src: "/galerie/2017/13.jpg", alt: "Vizite cu Studenții la Firme", year: 2017, project: "Vizită de studiu la Hotel Continental din Arad", order: 1 },
    { id: "2017-014", src: "/galerie/2017/14.jpg", alt: "Vizite cu Studenții la Firme", year: 2017, project: "Vizită de studiu la Hotel Continental din Arad", order: 1 },
    { id: "2017-015", src: "/galerie/2017/15.jpg", alt: "Vizite cu Studenții la Firme", year: 2017, project: "Vizită de studiu la Hotel Continental din Arad", order: 1 },
    { id: "2017-016", src: "/galerie/2017/16.jpg", alt: "Vizite cu Studenții la Firme", year: 2017, project: "Vizită de studiu la Hotel Continental din Arad", order: 1 },
    { id: "2017-017", src: "/galerie/2017/17.jpg", alt: "Vizite cu Studenții la Firme", year: 2017, project: "Vizită de studiu la Hotel Continental din Arad", order: 1 },
    { id: "2017-018", src: "/galerie/2017/18.jpg", alt: "Workshop dezvoltare personală", year: 2017, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2017-019", src: "/galerie/2017/19.jpg", alt: "Workshop dezvoltare personală", year: 2017, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2017-020", src: "/galerie/2017/20.jpg", alt: "Workshop dezvoltare personală", year: 2017, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2017-021", src: "/galerie/2017/21.jpg", alt: "Workshop dezvoltare personală", year: 2017, project: "Workshop-uri dezvoltare personală", order: 1 },
    { id: "2021-001", src: "/galerie/2021/01.jpg", alt: "Activități Caritabile", year: 2021, project: "Sprijin pentru familii nevoiașe", order: 1 },
    { id: "2021-002", src: "/galerie/2021/02.jpg", alt: "Activități Caritabile", year: 2021, project: "Sprijin pentru familii nevoiașe", order: 1 },
    { id: "2021-003", src: "/galerie/2021/03.jpg", alt: "Activități Caritabile", year: 2021, project: "Sprijin pentru familii nevoiașe", order: 1 },
    { id: "2021-004", src: "/galerie/2021/04.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-005", src: "/galerie/2021/05.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-006", src: "/galerie/2021/06.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-007", src: "/galerie/2021/07.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-008", src: "/galerie/2021/08.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-009", src: "/galerie/2021/09.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-010", src: "/galerie/2021/10.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-011", src: "/galerie/2021/11.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-012", src: "/galerie/2021/12.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-013", src: "/galerie/2021/13.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-014", src: "/galerie/2021/14.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-015", src: "/galerie/2021/15.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2021-016", src: "/galerie/2021/16.jpg", alt: "Zooland", year: 2021, project: "Vizită la Zooland", order: 1 },
    { id: "2022-001", src: "/galerie/2022/01.jpg", alt: "Activități Caritabile", year: 2022, project: "Sprijin pentru familii nevoiașe", order: 1 },
    { id: "2022-002", src: "/galerie/2022/02.jpg", alt: "Activități Caritabile", year: 2022, project: "Sprijin pentru familii nevoiașe", order: 1 },
    { id: "2022-003", src: "/galerie/2022/03.jpg", alt: "Activități Caritabile", year: 2022, project: "Sprijin pentru familii nevoiașe", order: 1 },
    { id: "2022-004", src: "/galerie/2022/04.jpg", alt: "Activități Caritabile", year: 2022, project: "Sprijin pentru familii nevoiașe", order: 1 },
    { id: "2022-005", src: "/galerie/2022/05.jpg", alt: "Activități Caritabile", year: 2022, project: "Sprijin pentru familii nevoiașe", order: 1 },
    { id: "2022-006", src: "/galerie/2022/06.jpg", alt: "Activități Educaționale", year: 2022, project: "Meditații și Remediale", order: 1 },
    { id: "2022-007", src: "/galerie/2022/07.jpg", alt: "Activități Educaționale", year: 2022, project: "Meditații și Remediale", order: 1 },
    { id: "2023-001", src: "/galerie/2023/01.jpg", alt: "Workshop dezvoltare personală", year: 2023, project: "Pentru Elevi", order: 1 },
    { id: "2023-002", src: "/galerie/2023/02.jpg", alt: "Workshop dezvoltare personală", year: 2023, project: "Pentru Elevi", order: 1 },
    { id: "2023-003", src: "/galerie/2023/03.jpg", alt: "Școală de vară", year: 2023, project: "Educație Financiară", order: 1 },
    { id: "2023-004", src: "/galerie/2023/04.jpg", alt: "Școală de vară", year: 2023, project: "Educație Financiară", order: 1 },
    { id: "2023-005", src: "/galerie/2023/05.jpg", alt: "Școală de vară", year: 2023, project: "Educație Financiară", order: 1 },
    { id: "2023-006", src: "/galerie/2023/06.jpg", alt: "Școală de vară", year: 2023, project: "Educație Financiară", order: 1 },
    { id: "2024-001", src: "/galerie/2024/01.jpeg", alt: "Eveniment comunitate", year: 2024, project: "Activități Caritabile de Crăciun", order: 1 },
    { id: "2024-002", src: "/galerie/2024/02.jpeg", alt: "Eveniment comunitate", year: 2024, project: "Activități Caritabile de Crăciun", order: 1 },
    { id: "2024-003", src: "/galerie/2024/03.jpeg", alt: "Eveniment comunitate", year: 2024, project: "Activități Caritabile de Crăciun", order: 1 },
    { id: "2024-004", src: "/galerie/2024/04.jpeg", alt: "Eveniment comunitate", year: 2024, project: "Activități Caritabile de Crăciun", order: 1 },
    { id: "2024-005", src: "/galerie/2024/05.jpeg", alt: "Activități Educaționale", year: 2024, project: "Meditații și Remediale", order: 1 },
    { id: "2024-006", src: "/galerie/2024/06.jpg", alt: "Activități Educaționale", year: 2024, project: "Meditații și Remediale", order: 1 },
    { id: "2024-007", src: "/galerie/2024/07.jpeg", alt: "Activități Educaționale", year: 2024, project: "Meditații și Remediale", order: 1 },
    { id: "2024-008", src: "/galerie/2024/08.jpeg", alt: "Activități Educaționale", year: 2024, project: "Meditații și Remediale", order: 1 },
    { id: "2025-001", src: "/galerie/2025/01.jpeg", alt: "Activități Caritabile", year: 2025, project: "08 Martie", order: 1 },
    { id: "2025-002", src: "/galerie/2025/02.jpeg", alt: "Activități Caritabile", year: 2025, project: "08 Martie", order: 1 },
    { id: "2025-003", src: "/galerie/2025/03.jpeg", alt: "Activități Caritabile", year: 2025, project: "08 Martie", order: 1 },
    { id: "2025-004", src: "/galerie/2025/04.jpeg", alt: "Activități Caritabile", year: 2025, project: "08 Martie", order: 1 },
    { id: "2025-005", src: "/galerie/2025/05.jpeg", alt: "Activități Educaționale", year: 2025, project: "Desfășurate în parteneriat cu Asociația „Oaza” din Arad", order: 1 },
    { id: "2025-006", src: "/galerie/2025/06.jpeg", alt: "Activități Educaționale", year: 2025, project: "Desfășurate în parteneriat cu Asociația „Oaza” din Arad", order: 1 },
    { id: "2025-007", src: "/galerie/2025/07.jpeg", alt: "Activități Educaționale", year: 2025, project: "Centrul Județean de Excelență Arad", order: 1 },
    { id: "2025-008", src: "/galerie/2025/08.jpeg", alt: "Activități Educaționale", year: 2025, project: "Centrul Județean de Excelență Arad", order: 1 },
    { id: "2025-009", src: "/galerie/2025/09.jpeg", alt: "Activități Educaționale", year: 2025, project: "Centrul Județean de Excelență Arad", order: 1 },
    { id: "2025-010", src: "/galerie/2025/10.jpeg", alt: "Activități Educaționale", year: 2025, project: "Centrul Județean de Excelență Arad", order: 1 },
    { id: "2025-011", src: "/galerie/2025/11.jpeg", alt: "Activități Educaționale", year: 2025, project: "Meditații și Remediale", order: 1 },
    { id: "2025-012", src: "/galerie/2025/12.jpeg", alt: "Activități Educaționale", year: 2025, project: "Meditații și Remediale", order: 1 },
    { id: "2025-013", src: "/galerie/2025/13.jpeg", alt: "Activități Educaționale", year: 2025, project: "Meditații și Remediale", order: 1 },
    { id: "2025-014", src: "/galerie/2025/14.jpeg", alt: "Activități Educaționale", year: 2025, project: "Meditații și Remediale", order: 1 },
    { id: "2025-015", src: "/galerie/2025/15.jpeg", alt: "Activități Educaționale", year: 2025, project: "Meditații și Remediale", order: 1 },
    { id: "2025-016", src: "/galerie/2025/16.jpeg", alt: "Activități Educaționale", year: 2025, project: "Activități STEM", order: 1 },
    { id: "2025-017", src: "/galerie/2025/17.jpeg", alt: "Activități Educaționale", year: 2025, project: "Activități STEM", order: 1 },


    // ...adaugă restul până la ~200
  ];

  const galleryPreviewCount = 6;

  const Tooltip = ({ text }) => (
      <motion.div
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          transition={{ duration: 0.2, type: "spring", stiffness: 250 }}
          className="absolute bottom-full mb-3 left-1/2 -translate-x-1/2 w-max max-w-xs px-4 py-2 rounded-xl bg-indigo-700 text-white text-sm font-medium shadow-xl text-center pointer-events-none opacity-0 group-hover:opacity-100"
      >
        {text}
        <div className="absolute top-full left-1/2 -translate-x-1/2 w-3 h-3 bg-indigo-700 rotate-45"></div>
      </motion.div>
  );

  return (
      <Router>
        <Routes>
          {/* Pagina principală */}
          <Route
              path="/"
              element={
                <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-blue-50 to-amber-50 p-6 space-y-12">
                  {/* Hero */}
                  <motion.section
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="grid md:grid-cols-2 gap-6 items-center"
                  >
                    <div className="space-y-4">
                      <h1 className="text-4xl md:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-amber-500">
                        Fundația ... Socrate
                      </h1>
                      <p className="text-lg max-w-2xl">
                        Peste un deceniu de educație ... „altfel” pentru elevi și studenți – dezvoltăm mintea, caracterul și potențialul.
                      </p>
                      <a href="#cta-section">
                        <Button className="text-lg px-8 py-4 bg-gradient-to-r from-indigo-600 to-amber-500 text-white shadow-lg hover:scale-105 transition">
                          Implică-te
                        </Button>
                      </a>
                    </div>

                    <div className="relative">
                      <img
                          src="https://images.unsplash.com/photo-1588072432836-e10032774350?auto=format&fit=crop&w=900&q=80"
                          alt="Elevi la atelier educațional"
                          className="rounded-2xl shadow-2xl object-cover w-full h-[320px]"
                      />
                    </div>
                  </motion.section>

                  {/* Despre noi */}
                  <section className="grid md:grid-cols-3 gap-6 bg-white/70 backdrop-blur rounded-2xl p-4 md:p-6">
                    <Card className="md:col-span-2">
                      <CardContent className="p-6 space-y-4">
                        <h2 className="text-2xl font-semibold text-gray-900">
                          Scopul nostru
                        </h2>

                        <p className="text-gray-700 leading-relaxed">
                          Scopul Fundației este de a contribui la dezvoltarea umană sustenabilă, respectiv
                          stimularea creșterii economice, susținerea dezvoltării sociale, sprijinirea diversității
                          și toleranței culturale, încurajarea protecției mediului.
                        </p>

                        <div className="space-y-2">
                          <p className="text-gray-800 font-medium">
                            Printre obiectivele Fundației se numără:
                          </p>

                          <ul className="list-disc pl-6 space-y-2 text-gray-700 leading-relaxed">
                            <li>
                              Dezvoltare personală și profesională prin derulare de activități de tip educativ-formativ
                              pentru copii, tineri și adulți, inclusiv training, consiliere, coaching și mentoring.
                            </li>

                            <li>
                              Promovarea inițiativelor, talentelor, spiritului întreprinzător, responsabilității și
                              performanței pentru crearea unui cadru compatibil cu valorile democrației.
                            </li>

                            <li>
                              Dezvoltarea bazei de cunoștințe teoretice și practice prin studii și cercetări în domeniile
                              social, economic, cultural, mediu și protecția mediului.
                            </li>

                            <li>
                              Sprijinul și integrarea persoanelor din grupuri defavorizate.
                            </li>
                          </ul>
                        </div>
                      </CardContent>

                    </Card>
                    <div className="rounded-xl overflow-hidden shadow-lg">
                      <img
                          src="https://media.istockphoto.com/id/143176157/photo/little-mr-smarty-pants.jpg?s=612x612&w=0&k=20&c=J_7n-o6k3-Yw3Ehc8wblUTREQJ2OjnKQ0xw5Rd20t7w="
                          alt="Educație și mentorat"
                          className="object-cover w-full h-full"
                      />
                    </div>
                  </section>

                  {/* Timeline */}


                  {/* Programe */}
                  <section className="space-y-6">
                    <h2 className="text-3xl font-bold text-center">Activități derulate </h2>
                    <div className="grid md:grid-cols-3 gap-6">
                      <Card className="hover:shadow-2xl transition transform hover:-translate-y-1 bg-gradient-to-br from-white to-indigo-50 border border-indigo-100 overflow-hidden">
                        <img
                            src="https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=600&q=80"
                            alt="Școli de vară"
                            className="w-full h-40 object-cover"
                        />
                        <CardContent className="p-6">
                          <h3 className="text-xl font-semibold">Școli de vară</h3>
                          <p>Școlile de vară sunt programe educaționale și recreative organizate în perioada vacanței, care combină învățarea prin experiență cu activități practice și colaborative, contribuind la dezvoltarea cunoștințelor și abilităților participanților.</p>
                        </CardContent>
                      </Card>

                      <Card className="hover:shadow-2xl transition transform hover:-translate-y-1 bg-gradient-to-br from-white to-indigo-50 border border-indigo-100 overflow-hidden">
                        <img
                            src="https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=600&q=80"
                            alt="Consiliere pentru dezvoltare personală și profesională"
                            className="w-full h-40 object-cover"
                        />
                        <CardContent className="p-6">
                          <h3 className="text-xl font-semibold">Consiliere pentru dezvoltare personală și profesională</h3>
                          <p>Consilierea pentru dezvoltare personală și profesională constă în activități de orientare și sprijin individual sau de grup, menite să ajute participanții să își identifice potențialul, să își dezvolte competențe relevante și să ia decizii informate privind parcursul educațional și profesional.</p>
                        </CardContent>

                      </Card>




                      <Card className="hover:shadow-2xl transition transform hover:-translate-y-1 bg-gradient-to-br from-white to-indigo-50 border border-indigo-100 overflow-hidden">
                        <img
                            src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=600&q=80"
                            alt="Workshop-uri și seminarii în domenii STEM"
                            className="w-full h-40 object-cover"
                        />
                        <CardContent className="p-6">
                          <h3 className="text-xl font-semibold">Școala ...  „altfel”</h3>
                          <p> Workshop-uri și seminarii în domenii STEM. Școala de excelență în domeniile Matematică și Fizică. Workshop-uri de dezvoltare antreprenorială și educație financiară.</p>
                        </CardContent>
                      </Card>
                      <Card className="hover:shadow-2xl transition transform hover:-translate-y-1 bg-gradient-to-br from-white to-indigo-50 border border-indigo-100 overflow-hidden">
                        <img
                            src="https://cdn.edupedu.ro/wp-content/uploads/2022/08/dreamstime_s_38767133.jpg"
                            alt="Consiliere pentru dezvoltare personală și profesională"
                            className="w-full h-40 object-cover"
                        />
                        <CardContent className="p-6">
                          <h3 className="text-xl font-semibold">Activități remediale</h3>
                          <p>Activități pentru elevii de gimnaziu care întâmpină dificultăți în înțelegerea și aplicarea conținuturilor predate la anumite discipline. Aceste activități au rolul de a sprijini recuperarea lacunelor, consolidarea competențelor de bază și îmbunătățirea performanțelor școlare.</p>
                        </CardContent>

                      </Card>
                      <Card className="hover:shadow-2xl transition transform hover:-translate-y-1 bg-gradient-to-br from-white to-indigo-50 border border-indigo-100 overflow-hidden">
                        <img
                            src="https://www.billabonghighschool.com/blogs/wp-content/uploads/2024/02/blog-25-Role-of-Parents-in-Child-Education.jpg"
                            alt="Consiliere pentru dezvoltare personală și profesională"
                            className="w-full h-40 object-cover"
                        />
                        <CardContent className="p-6">
                          <h3 className="text-xl font-semibold">Școala ... pentru părinți</h3>
                          <p>Rolul părinților în educația copiilor este esențial. Workshop-uri privind modul în care părinții pot sprijini școala, cum pot motiva copiii să învețe rolul și impactul „ecranelor” în educație.</p>
                        </CardContent>

                      </Card>
                      <Card className="hover:shadow-2xl transition transform hover:-translate-y-1 bg-gradient-to-br from-white to-indigo-50 border border-indigo-100 overflow-hidden">
                        <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRc6UdTwV8EEguyluCa3iOFxpGTDq_hE3jCfQ&s"
                            alt="Activități caritabile"
                            className="w-full h-40 object-cover"
                        />
                        <CardContent className="p-6">
                          <h3 className="text-xl font-semibold">Activități caritabile</h3>
                          <p> Sprijinirea elevilor din familii vulnerabile cu rechizite și cadouri de sărbători.</p>
                        </CardContent>

                      </Card>





                    </div>
                  </section>
                  <section className="w-full py-16 md:py-24 bg-gradient-to-b from-slate-100 to-white">
                    <div className="w-full max-w-6xl mx-auto px-4 md:px-8">

                      <div className="w-full bg-white rounded-3xl shadow-xl border border-gray-200 p-8 md:p-14 space-y-12">

                        <h3 className="text-3xl md:text-5xl font-extrabold text-gray-900 text-center leading-tight">
                          Istoric de activități
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">

                          <div className="bg-slate-50 rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition">
                            <h4 className="text-xl font-bold text-gray-900 mb-3">
                              Activități educaționale în domeniul STEAM
                            </h4>
                            <p className="text-gray-700 leading-relaxed">
                              În principal matematică și fizică, în parteneriat cu Asociația Academia Generației de Mâine,
                              inclusiv un proiect finanțat de către Centrul Județean de Cultură Arad, prin care au fost vizați
                              în calitate de grup țintă{" "}
                              <span className="font-semibold text-gray-900">150 de elevi</span> din licee din județul Arad,
                              care au beneficia de workshop-uri și mentorat în domeniul STEM.
                            </p>
                          </div>

                          <div className="bg-slate-50 rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition">
                            <h4 className="text-xl font-bold text-gray-900 mb-3">
                              Activități remediale
                            </h4>
                            <p className="text-gray-700 leading-relaxed">
                              Activități remediale pentru Matematică și Fizică pentru copii din familii vulnerabile, ce provin din medii
                              dezavantajate social și economic, în parteneriat cu Asociația Oaza, asociație înființată în 1996,
                              care le oferă servicii alternative de îngrijire și sprijin, pe timpul zilei.
                            </p>
                          </div>
                          {/* Made by Mycroft S*/}
                          <div className="bg-slate-50 rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition">
                            <h4 className="text-xl font-bold text-gray-900 mb-3">
                              Activități STEM la nivel de excelență
                            </h4>
                            <p className="text-gray-700 leading-relaxed">
                              Matematică și Fizică la nivel de olimpiadă, în parteneriat cu Asociația Academia Generației de Mâine și Centrul Județean de Excelență Arad.
                            </p>
                          </div>

                          <div className="bg-slate-50 rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition">
                            <h4 className="text-xl font-bold text-gray-900 mb-3">
                              Școli de vară
                            </h4>
                            <p className="text-gray-700 leading-relaxed">
                              Școli de vară în antreprenoriat și educație financiară
                              în parteneriat cu Colegiul Național „Moise Nicoară”, Colegiul Economic Arad,
                              Colegiul Particular „Vasile Goldiș”.
                            </p>
                          </div>
                          <div className="bg-slate-50 rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition">
                            <h4 className="text-xl font-bold text-gray-900 mb-3">
                              Consiliere pentru dezvoltare personală și profesională
                            </h4>
                            <p className="text-gray-700 leading-relaxed">
                              Consiliere individuală și workshop-uri de autocunoaștere, stabilire obiective, elaborare plan de carieră.
                            </p>
                          </div>

                          <div className="bg-slate-50 rounded-2xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition">
                            <h4 className="text-xl font-bold text-gray-900 mb-3">
                              WEBINAR "ANTIDOT FISCAL"
                            </h4>
                            <p className="text-gray-700 leading-relaxed">
                              Implicarea alături de autorul și titularul de marcă „Antidot Fiscal” Conf.univ.dr. Marius Boiță în vederea promovării educației fiscale.
                            </p>
                          </div>

                        </div>
                      </div>
                    </div>
                  </section>

                  {/* Galerie preview (o singură dată) */}
                  <section className="space-y-6">
                    <div className="text-center space-y-2">
                      <h2 className="text-3xl font-bold">Galerie</h2>
                      <p className="text-gray-700 max-w-3xl mx-auto">
                        Câteva momente din activitățile noastre. Pentru toate fotografiile, accesează galeria completă.
                      </p>
                    </div>

                    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
                      {galleryPhotos.slice(0, galleryPreviewCount).map((img, idx) => (
                          <div key={img.id ?? idx} className="rounded-2xl overflow-hidden shadow-lg bg-white/70">
                            <img src={img.src} alt={img.alt} className="w-full h-48 object-cover" loading="lazy" />
                            <div className="p-3 text-sm text-gray-700">
                              <span className="font-semibold">{img.alt}</span>
                              <div className="text-xs text-gray-500">
                                {img.year} • {img.project}
                              </div>
                            </div>
                          </div>
                      ))}
                    </div>

                    <div className="flex justify-center">
                      <Link to="/galerie">
                        <Button className="px-6">Vezi toată galeria</Button>
                      </Link>
                    </div>
                  </section>

                  {/* Membrii (folosește teamMembers, ca să se vadă Prof. univ...) */}
                  <section className="space-y-6">
                    <h2 className="text-3xl font-bold text-center">Colaboratori</h2>
                    <div className="grid md:grid-cols-3 gap-6">
                      {teamMembers.map((m, idx) => (
                          <Card
                              key={idx}
                              className="hover:shadow-2xl transition transform hover:-translate-y-1 bg-gradient-to-br from-white to-indigo-50 border border-indigo-100 overflow-hidden"
                          >
                            <div className="w-full flex justify-center pt-6">
                              <img
                                  src={m.image}
                                  alt={m.name}
                                  className="w-32 h-32 rounded-full object-cover border-4 border-white shadow-lg"
                              />
                            </div>
                            <CardContent className="p-6 space-y-1">
                              <h3 className="text-xl font-semibold">{m.name}</h3>
                              <p className="text-indigo-700 font-medium">{m.role}</p>
                              {m.subtitle ? <p className="text-sm text-gray-700">{m.subtitle}</p> : null}
                            </CardContent>
                          </Card>
                      ))}
                    </div>
                  </section>

                  {/* CTA */}
                  <motion.section
                      id="cta-section"
                      whileHover={{ scale: 1.02 }}
                      className="bg-gradient-to-r from-indigo-100 to-amber-100 rounded-2xl p-8 text-center space-y-4"
                  >
                    <h2 className="text-2xl font-bold">Vrei să faci parte din schimbare?</h2>
                    <p>Devino partener sau susținător al Fundației Socrate.</p>

                    <div className="flex justify-center gap-4 flex-wrap">
                      <div className="relative group inline-block">
                        <Link to="/doneaza"><Button>Donează</Button></Link>
                        <Tooltip text="Orice donație ajută direct proiectele noastre!" />
                      </div>

                      <div className="relative group inline-block">
                        <Link to="/contact"><Button>Contact</Button></Link>
                        <Tooltip text="Scrie-ne pentru întrebări sau parteneriate!" />
                      </div>
                    </div>
                  </motion.section>

                  {/* Footer */}
                  <footer className="text-center text-sm text-gray-500 pt-6">
                    © {new Date().getFullYear()} Fundația Socrate – Educație pentru viitor
                  </footer>
                </div>
              }
          />

          {/* Paginile individuale */}
          <Route path="/doneaza" element={<Doneaza />} />
          <Route path="/voluntar" element={<Voluntar />} />
          <Route path="/directioneaza-3-la-suta" element={<Directioneaza3LaSuta />} />
          <Route path="/contact" element={<Contact />} />

          {/* Pagina Galerie separată */}
          <Route path="/galerie" element={<Galerie photos={galleryPhotos} />} />
        </Routes>
      </Router>
  );
}
